<template>
    <div class="input-group-wrapper">
        <div class="input-group-inner" v-if="!_.isEmpty(field.subFields)">
            <div>
                <template v-if="_.isArray(inputGroup) && !_.isEmpty(inputGroup) && groupIsVisbile">



                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.other_income'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Other Incomes</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_general'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">General Expenses</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_discretionary'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Discretionary Expenses</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_transport'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Transport Expenses</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_other'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Other Expenses</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="['asset_liabilities', 'aai.asset_liabilities'].includes(field.field_mapping)">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Assets & Liabilities</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.liabilities'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Unsecured Liabilities</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'investment_properties'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Investment Properties</h4>
                    </div>

                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.dependents'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Dependents</h4>
                    </div>

                    <template v-for="(group, groupKey) in inputGroup">
                        <div
                            :class="
                                !_.isEmpty(field.field_mapping) && field.field_mapping !== field.field_mapping_parent
                                    ? `group-${_.kebabCase(field.field_mapping)}`
                                    : `group-${_.kebabCase(getFieldId(field))}`
                            "
                        >
                            <div class="fin-mb-5 group-title" v-if="field.field_mapping == 'applicants'">
                                <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">
                                    Applicant {{ groupKey + 1 }} {{ getApplicantName(groupKey) }}
                                </h4>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.addresses'">
                                <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">
                                    {{ !groupKey ? "Current" : "Previous" }} Address {{ groupKey > 0 ? `#${groupKey}` : "" }}
                                </h4>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    v-if="groupKey"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Address
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'investment_properties'">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Investment Property #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Investment Property
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.other_income'">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Other Income #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    v-if="!['Investment Property Income'].includes(inputGroup[groupKey].label)"
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Other Income
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_general' && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    General Expense #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove General Expense
                                </el-button>
                            </div>

                            <div
                                class="fin-my-5 group-title"
                                v-if="field.field_mapping == 'aai.expenses_discretionary' && showGroup"
                            >
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Discretionary Expense #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Discretionary Expense
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_transport' && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Transport Expense #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Transport Expense
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.expenses_other' && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Other Expense #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Other Expense
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title"  v-if="['asset_liabilities', 'aai.asset_liabilities'].includes(field.field_mapping) && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Asset & Liability #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    v-if="!['1', '3'].includes(inputGroup[groupKey].item)"
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Asset & Liability
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.liabilities' && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Liability #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Liability
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'aai.dependents' && showGroup">
                                <h5 class="fin-text-xs md:fin-text-base lg:fin-text-sm fin-font-light">
                                    Dependent #{{ groupKey + 1 }}
                                </h5>
                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Dependent
                                </el-button>
                            </div>

                            <div class="fin-my-5 group-title" v-if="field.field_mapping == 'employment_histories'">
                                <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">
                                    {{
                                        _.isNull(_.get(formData, `${path}.${groupKey}.employment_status_id`))
                                            ? ""
                                            : _.isNull(_.get(formData, `${path}.${groupKey}.is_current`))
                                            ? ""
                                            : _.get(formData, `${path}.${groupKey}.is_current`) == "1"
                                            ? "Current "
                                            : "Previous "
                                    }}Employment
                                </h4>

                                <el-button
                                    class="fin-text-danger fin-p-0"
                                    v-if="groupKey"
                                    type="text"
                                    size="mini"
                                    @click="removeField(field, path, groupKey)"
                                >
                                    Remove Employment
                                </el-button>
                            </div>

                            <div class="group-content" v-if="showGroup">
                                <template v-for="(subField, subFieldKey) in field.subFields">
                                    <field-group :field="subField" :field-key="subFieldKey" :path="`${path}.${groupKey}`">
                                        <template v-if="subField.type == 'pageColumns'">
                                            <component
                                                :value="fieldValue(subField.type !== 'customField' ? '1' : '5', groupKey)"
                                                :key="`${_uid}-${subFieldKey}`"
                                                :is="subField.component"
                                                :field="subField"
                                                :field-key="subFieldKey"
                                                :path="subField.type !== 'customField' ? `${path}.${groupKey}` : ''"
                                                :form-store="formStore"
                                            ></component>
                                        </template>
                                        <template v-else>
                                            <component
                                                :value="fieldValue(subField.type !== 'customField' ? '2' : '5', groupKey, subField)"
                                                :key="`${_uid}-${subFieldKey}-${getFieldId(subField)}`"
                                                :is="subField.component"
                                                :field="subField"
                                                :field-key="subFieldKey"
                                                :path="subField.type !== 'customField' ? `${path}.${groupKey}.${getFieldId(subField)}` : `customFields.${getFieldId(subField)}`"
                                                :form-store="formStore"
                                            ></component>
                                        </template>
                                    </field-group>
                                </template>
                            </div>
                        </div>
                    </template>
                </template>

                <template v-else-if="!_.isArray(inputGroup) && groupIsVisbile">
                    <div class="fin-my-5 group-title" v-if="field.field_mapping == 'rent_reference'">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Agent/Landlord Details</h4>
                    </div>

                    <div
                        :class="
                            !_.isEmpty(field.field_mapping) && field.field_mapping !== field.field_mapping_parent
                                ? `group-${_.kebabCase(field.field_mapping)}`
                                : `group-${_.kebabCase(getFieldId(field))}`
                        "
                    >
                        <div v-if="showGroup" class="group-content">
                            <template v-for="(subField, subFieldKey) in field.subFields">
                                <field-group :field="subField" :field-key="subFieldKey" :path="path">
                                    <template v-if="subField.type == 'pageColumns'">
                                        <component
                                            :value="fieldValue(subField.type !== 'customField' ? '3' : '5', null, null)"
                                            :key="`${_uid}-${subFieldKey}`"
                                            :is="subField.component"
                                            :field="subField"
                                            :field-key="subFieldKey"
                                            :path="subField.type !== 'customField' ? `${path}` : ''"
                                            :form-store="formStore"
                                        ></component>
                                    </template>
                                    <template v-else>
                                        <component
                                            :value="fieldValue(subField.type !== 'customField' ? '4' : '5', null, subField)"
                                            :key="`${_uid}-${subFieldKey}-${getFieldId(subField)}`"
                                            :is="subField.component"
                                            :field="subField"
                                            :field-key="subFieldKey"
                                            :path="subField.type !== 'customField' ? `${path}.${getFieldId(subField)}` : `customFields.${getFieldId(subField)}`"
                                            :form-store="formStore"
                                        ></component>
                                    </template>
                                </field-group>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <div class="group-actions fin-my-5">
            <div v-if="field.field_mapping == 'aai.addresses'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingAddresses)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add Previous Address</el-button>
                </div>
                <div v-else>
                    <div class="fin-my-5 group-title">
                        <h4 class="fin-text-base md:fin-text-base lg:fin-text-lg fin-font-light">Current & Previous Addresses</h4>
                    </div>
                    <h4 class="fin-text-body">Sharing Addresses from Applicant 1</h4>
                </div>
            </div>

            <div v-if="field.field_mapping == 'aai.other_income'">
                <el-button type="primary" size="mini" @click="addField(field, path)">Add Other Income</el-button>
            </div>

            <div v-if="field.field_mapping == 'aai.expenses_general'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingExpenses)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add General Expense</el-button>
                </div>
                <div v-else>
                    <h4 class="fin-text-body">Sharing General Expenses from Applicant 1</h4>
                </div>
            </div>

            <div v-if="field.field_mapping == 'aai.expenses_discretionary'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingExpenses)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add Discretionary Expense</el-button>
                </div>
                <div v-else>
                    <h4 class="fin-text-body">Sharing Discretionary Expenses from Applicant 1</h4>
                </div>
            </div>

            <div v-if="field.field_mapping == 'aai.expenses_transport'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingExpenses)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add Transport Expense</el-button>
                </div>
                <div v-else>
                    <h4 class="fin-text-body">Sharing Transport Expenses from Applicant 1</h4>
                </div>
            </div>

            <div v-if="field.field_mapping == 'aai.expenses_other'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingExpenses)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add Other Expense</el-button>
                </div>
                <div v-else>
                    <h4 class="fin-text-body">Sharing Other Expenses from Applicant 1</h4>
                </div>
            </div>

            <div v-if="['asset_liabilities', 'aai.asset_liabilities'].includes(field.field_mapping)">
                <el-button type="primary" size="mini" @click="addField(field, path)">Add Asset & Liability</el-button>
            </div>

            <div v-if="field.field_mapping == 'aai.liabilities'">
                <el-button type="primary" size="mini" @click="addField(field, path)">Add Unsecured Liability</el-button>
            </div>

            <div v-if="field.field_mapping == 'employment_histories'">
                <el-button type="primary" size="mini" @click="addField(field, path)">Add Employment</el-button>
            </div>

            <div v-if="field.field_mapping == 'investment_properties'">
                <el-button type="primary" size="mini" @click="addField(field, path)">Add Investment Property</el-button>
            </div>

            <div v-if="field.field_mapping == 'aai.dependents'">
                <div v-if="!isApplicantTwo || (isApplicantTwo && !sharingDependents)">
                    <el-button type="primary" size="mini" @click="addField(field, path)">Add Dependent</el-button>
                </div>
                <div v-else>
                    <h4 class="fin-text-body">Sharing Dependents from Applicant 1</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"
import { mapGetters } from "vuex"

import fieldGroup from "@tenant/app-form/components/form/fieldGroup"

export default {
    name: "InputGroup",

    components: {
        fieldGroup,
    },

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number],
        },
        value: {
            required: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },

    computed: {
        pageData() {
            if (_.isEmpty(this.formPages)) return []
            return this.formPages.filter((page) => _.isArray(page))
        },
        subFields() {
            if (_.isEmpty(this.field.subFields)) return []
            return this.field.subFields
        },
        isApplicantTwo() {
            return this.path.includes("applicants.1")
        },
        isCurrentAddress() {
            return this.path.includes("addresses.0")
        },
        sharingExpenses() {
            if (this.isApplicantTwo) {
                return this.formData.application.applicants[1].aai.expenses_shared == "1" ? true : false
            }
            return false
        },
        sharingDependents() {
            if (this.isApplicantTwo) {
                return this.formData.application.applicants[1].aai.is_sharing_dependents == "1" ? true : false
            }
            return false
        },
        sharingAddresses() {
            if (this.isApplicantTwo) {
                return this.formData.application.applicants[1].aai.is_sharing_addresses == "1" ? true : false
            }
            return false
        },

        showGroup() {
            if (this.sharingExpenses) {
                if (
                    [
                        "application.applicants.1.aai.expenses_general",
                        "application.applicants.1.aai.expenses_discretionary",
                        "application.applicants.1.aai.expenses_transport",
                        "application.applicants.1.aai.expenses_other",
                    ].includes(this.path)
                ) {
                    return false
                }
            }

            switch (this.field.field_mapping_parent) {
                case "aai.addresses":
                    switch (this.field.field_mapping) {
                        case "rent":
                            if (!this.isCurrentAddress) {
                                return false
                            }
                            break
                    }
                    break
            }

            return true
        },
    },

    data() {
        return {
            inputGroup: [],
            groupIsVisbile: true,
        }
    },

    mounted() {

    },

    methods: {
        getApplicantName(index) {
            let applicant = this.formData.application.applicants[index]
            if (applicant) {
                let firstName = _.get(applicant, "first_name", null) || ""
                let lastName = _.get(applicant, "last_name", null) || ""
                return firstName && lastName ? ` - ${firstName} ${lastName}` : ""
            }
        },

        addField(field, path) {
            let fieldData = this.generateSubFields(field)
            let pathData = _.get(this.formData, path)

            switch (field.field_mapping_parent) {
                case "applicants":
                    switch (field.field_mapping) {
                        case "aai.addresses":
                            break
                        case "aai.asset_liabilities":
                            _.set(fieldData, "id", _.size(pathData))
                            break
                        case "aai.liabilities":
                            _.set(fieldData, "id", _.size(pathData))
                            break
                        case "aai.other_income":
                            _.set(fieldData, "id", _.size(pathData))
                            break
                        case "investment_properties":
                            let applicantPath = path.split(".investment_properties")[0]
                            let applicantOtherIncome = _.get(this.formData, `${applicantPath}.aai.other_income`)
                            let applicantOtherIncomeId = _.size(applicantOtherIncome)
                            applicantOtherIncome.push({ id: applicantOtherIncomeId })
                            _.set(fieldData, "asset_liability_income.id", applicantOtherIncomeId)
                            let applicantAssetLiabilities = _.get(this.formData, `${applicantPath}.aai.asset_liabilities`)
                            let applicantAssetLiabilitiesId = _.size(applicantAssetLiabilities)
                            applicantAssetLiabilities.push({ id: applicantAssetLiabilitiesId })
                            _.set(fieldData, "asset_liability.id", applicantAssetLiabilitiesId)
                            break
                    }

                case "commercial_financial_detail":
                    switch (field.field_mapping) {
                        case "asset_liabilities":
                            _.set(fieldData, "id", _.size(pathData))
                            break
                    }
                    break
            }

            pathData.push(fieldData)
        },

        removeField(field, path, index) {
            let pathData = _.get(this.formData, path)
            let formData

            console.warn('field.field_mapping_parent', field.field_mapping_parent)
            console.warn('field.field_mapping', field.field_mapping)

            switch (field.field_mapping_parent) {
                case "applicants":
                    switch (field.field_mapping) {
                        case "investment_properties":
                            let fieldData = pathData[index]
                            let applicantPath = path.split(".investment_properties")[0]
                            let otherIncome = _.get(this.formData, `${applicantPath}.aai.other_income`, [])
                            Vue.delete(otherIncome, fieldData.asset_liability_income.id)
                            let assetAndLiability = _.get(this.formData, `${applicantPath}.aai.asset_liabilities`, [])
                            Vue.delete(assetAndLiability, fieldData.asset_liability.id)
                            // set delete object
                            if (!_.has(this.formData, `${path}_delete`, false)) {
                                _.set(this.formData, `${path}_delete`, [])
                            }
                            formData = _.get(this.formData, `${path}_delete`)
                            formData.push(pathData[index])
                            this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${path}_delete`)
                            break
                        default:
                            // set delete object
                            if (!_.has(this.formData, `${path}_delete`, false)) {
                                _.set(this.formData, `${path}_delete`, [])
                            }
                            formData = _.get(this.formData, `${path}_delete`)
                            formData.push(pathData[index])
                            this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${path}_delete`)
                            break
                    }

                case "commercial_financial_detail":
                    // set delete object
                    if (!_.has(this.formData, `${path}_delete`, false)) {
                        _.set(this.formData, `${path}_delete`, [])
                    }
                    formData = _.get(this.formData, `${path}_delete`)
                    formData.push(pathData[index])
                    this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${path}_delete`)
                    break
            }

            Vue.delete(pathData, index)
        },

        fieldValue(section, groupKey, subField) {
            switch (section) {
                case "1":
                    return _.get(this.inputGroup, groupKey)
                    break
                case "2":
                    let subFieldId = this.getFieldId(subField)

                    // turn a comma seperated sub field mapping into an array
                    let subFieldMapping
                    let subFieldMappingArray = subFieldId ? String(subFieldId).split(",") : []
                    if ([0, 1].includes(_.size(subFieldMappingArray))) {
                        subFieldMapping = subFieldId
                    } else {
                        subFieldMapping = subFieldMappingArray.map((subFieldMapping) => subFieldMapping.trim())
                    }

                    if (_.isArray(subFieldMapping)) {
                        let mappingObject = {}
                        subFieldMapping.forEach((mapping) => {
                            _.set(mappingObject, mapping, _.get(this.inputGroup, `${groupKey}.${mapping}`))
                        })
                        return mappingObject
                    } else {
                        return _.get(this.inputGroup, `${groupKey}.${subFieldMapping}`)
                    }
                    break
                case "3":
                    return this.inputGroup
                    break
                case "4":
                    // if (_.isEmpty(this.inputGroup)) return _.get(this.formData, this.getFieldId(subField))
                    return _.get(this.inputGroup, this.getFieldId(subField))
                    break
                case "5":
                    return _.get(this.formData.customFields, this.getFieldId(subField))
                    break
            }
        },
    },

    watch: {
        sharingAddresses: {
            handler(sharingAddresses) {
                switch (this.field.field_mapping_parent) {
                    case "applicants":
                        switch (this.field.field_mapping) {
                            case "aai.addresses":
                                if (this.isApplicantTwo) {
                                    this.groupIsVisbile = sharingAddresses ? false : true
                                }
                                break
                        }
                        break
                }
            },
            immediate: true,
        },
        inputGroup: {
            handler(inputGroup) {
                switch (this.field.field_mapping_parent) {
                    case "applicants":
                        switch (this.field.field_mapping) {
                            case "investment_properties":
                                if (!_.isEmpty(inputGroup)) {
                                    inputGroup.forEach((inputGroup, inputGroupIndex) => {
                                        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${this.path}.${inputGroupIndex}.asset_liability.id`)
                                        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${this.path}.${inputGroupIndex}.asset_liability_income.id`)
                                    })
                                }
                                break
                        }
                        break
                }
                let path = String(this.path).split(".")
                this.setPathData(path, inputGroup)
            },
            deep: true,
        },
        value: {
            handler(value) {
                if (!_.isEmpty(value)) {
                    this.inputGroup = value
                }
            },
            immediate: true,
        },
        formData: {
            handler() {
                if (this.field.field_mapping_parent == "rent" && this.field.field_mapping == "rent_reference") {
                    let isPreviousAddress = !this.path.includes("aai.addresses.0")
                    let addressPath = this.path.replace(".rent.rent_reference", "")
                    let addressData = _.get(this.formData, addressPath, false)
                    let residentialStatusId = addressData.residential_status_id
                    if (addressData) {
                        // if the address is a previous address and not owned outright or mortgaged
                        if ([3, 4, 5, 6].includes(Number(addressData.residential_status_id)) && isPreviousAddress) {
                            this.groupIsVisbile = false
                        } else {
                            this.groupIsVisbile = true
                        }
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped></style>
